import React from 'react'

const PropertyButton = ({ label }) => {
    return (
        <div className="property-button">
            <p>{label}</p>
        </div>
    )
}
export default PropertyButton